module.exports = __webpack_public_path__ + "img/4.83afc1cd.jpg";